<template>
  <div
    class="file-preview"
    :class="{
      'file-preview--fw': fullWidth,
    }"
    :data-type="type"
  >
    <div class="file-preview-img">
      <img v-if="type === 'image'" :src="url" @click="$emit('click')" />

      <template v-if="type === 'video'">
        <video v-if="showVideo" controls :src="url"></video>
        <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path d="M11 24V8L25 15.7333L11 24Z" stroke="#8E9CBB" stroke-width="2" stroke-linejoin="round" />
        </svg>
      </template>

      <svg
        v-if="type === 'doc'"
        class="file-preview-img__icon"
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z"
          fill="#2B579A"
        />
        <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#2B579A" stroke-width="3" />
      </svg>

      <svg
        v-if="type === 'pdf'"
        class="file-preview-img__icon"
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#E30000" stroke-width="3" />
        <path
          d="M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z"
          stroke="#E30000"
          stroke-width="2"
        />
      </svg>

      <template v-if="showActions">
        <template v-if="type === 'image' || type === 'video'">
          <div v-if="loadImages || preview" class="file-preview__overlay" @click="$emit('click')">
            <div class="file-preview__icons">
              <a v-if="loadImages" class="file-preview__icon" :href="url" download>
                <svg-icon name="upload-light" color="white" :size="24"></svg-icon>
              </a>

              <span v-if="preview" class="file-preview__icon">
                <svg-icon
                  v-if="type === 'image' || (type === 'video' && !showVideo)"
                  name="eye"
                  :size="32"
                  color="white"
                ></svg-icon>
              </span>
            </div>
          </div>
        </template>

        <template v-else>
          <a v-if="loadFiles" class="file-preview__overlay" :href="url" download>
            <div class="file-preview__icons">
              <span class="file-preview__icon">
                <svg-icon name="upload-light" color="white" :size="24"></svg-icon>
              </span>
            </div>
          </a>
        </template>
      </template>
    </div>

    <div v-if="fileName" class="file-preview__name">
      {{ fileName }}
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/svg-icon";

export default {
  name: "file-preview",
  components: { SvgIcon },

  props: ["type", "name", "url", "actions", "showVideo", "fullWidth"],

  data() {
    return {
      fileName: "",
    };
  },

  computed: {
    actionsList() {
      if (!this.actions) return [];
      if (this.actions === true) return ["loadFiles", "preview"];
      return this.actions.split(",");
    },
    loadFiles() {
      return this.actionsList.includes("loadFiles");
    },
    loadImages() {
      return this.actionsList.includes("loadImages");
    },
    preview() {
      return this.actionsList.includes("preview");
    },
    showActions() {
      if (this.type === "video" && this.showVideo) return false;
      return this.actionsList.length > 0;
    },
  },
  created() {
    this.fileName = this.name || this.url.split("/").pop();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.file-preview {
  width: 136px;
  position: relative;

  &--fw {
    width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  &-img {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 6px;
    width: 100%;
    padding-bottom: 74.63%;
    border: 1px solid #dfe4ef;

    img,
    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: inherit;
    }

    svg {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
  }

  &[data-type="doc"],
  &[data-type="pdf"] {
    .file-preview-img {
      cursor: default;
    }
  }

  &__name {
    margin-top: 7px;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.1;
    padding: 0 0 3px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__overlay {
    opacity: 0;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
  }

  &__icons {
    display: flex;
    align-items: center;
  }

  &__icon {
    margin: 0 8px;
  }

  &:hover {
    .file-preview__overlay {
      opacity: 1;
    }
  }

  @include onlyMobile {
    &:not(&--fw) {
      width: 108px;
    }

    &__name {
      font-size: 10px;
      text-align: left;
    }
  }
}
</style>
